import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthProvider';

const HelpHeader = () => {
	const { user } = useAuth();
	const { i18n } = useTranslation();

	return (
		<header className="help-header">
			<div className="help-header__inner">
				<NavLink to={`/${i18n.language}`} className="help-header__brand">
					<img src={`${process.env.PUBLIC_URL}/images/saydalani_logo.png`} alt="Saydalani" />
					<span>Centre d'aide</span>
				</NavLink>
				<NavLink to={user ? '/dashboard' : `/${i18n.language}/login`} className="help-header__cta">
					{user ? "Retour à l'application" : 'Se connecter'}
				</NavLink>
			</div>
		</header>
	);
};

export default HelpHeader;
